import { formatDistanceToNow, isValid } from 'date-fns';
import { i18n } from '@/plugins/i18n';
import { enUS, ja } from 'date-fns/locale';
import { formatDefault } from '@/filters/formatDefault';

/**
 * @description return relative time from now in a sentence
 *
 * @param val date
 * @param locale 'en' or 'ja' locale
 * @param addSuffix show suffix if now is earlier or later than given date (e.g. 'in about 1 year')
 */
export const formatFromNow = (val: string, addSuffix = false) => {
  if (!val || !isValid(new Date(val))) {
    return formatDefault(val);
  }
  // https://date-fns.org/v2.12.0/docs/Locale
  const locale = i18n.locale === 'ja' ? ja : enUS;

  return formatDistanceToNow(
    // https://date-fns.org/v2.11.0/docs/formatDistanceToNow
    new Date(val), { addSuffix, locale });
};
